import React from 'react'
import { useSelector } from 'react-redux'
import { ApplicationState } from 'store'
import { ProfileNameProps } from './interfaces'
import css from './ProfileName.module.css'
import { useProfileIcon } from '@lynx/client-core/src/hooks/useProfileIcon'

export const ProfileName = ({ handleNameChange, profileInputState }: ProfileNameProps): React.ReactElement => {
	const { icon } = useProfileIcon()
	const {
		profile: { gravatarUrl }
	} = useSelector((state: ApplicationState) => state)

	return (
		<div onClick={handleNameChange} className={css['profile_container']}>
			<div className={css['profile_displayName']}>{profileInputState}</div>
			<div className={css['profile_image']}>{icon}</div>
		</div>
	)
}
